import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, Text, StyleSheet } from 'react-native';
import { Paprika, PaprikaEntry } from '../../../../styles/theme';

interface Stats {
  recipe: number;
  dining: number;
  note: number;
  skip: number;
}

interface Props {
  stats: Stats;
}

export function WeekSummaryLine({ stats }: Props) {
  const { t } = useTranslation();

  // The count renders in its own <Text>, so these keys carry only the noun —
  // pluralized by `count` without interpolating it.
  const items: Array<{ count: number; label: string; dotColor: string }> = [
    { count: stats.recipe, label: t('thisWeek.summary.recipes', { count: stats.recipe }), dotColor: Paprika.primary },
  ];

  if (stats.dining > 0) {
    items.push({ count: stats.dining, label: t('thisWeek.summary.dining', { count: stats.dining }), dotColor: PaprikaEntry.dining.color });
  }
  if (stats.note > 0) {
    items.push({ count: stats.note, label: t('thisWeek.summary.notes', { count: stats.note }), dotColor: PaprikaEntry.note.color });
  }
  if (stats.skip > 0) {
    items.push({ count: stats.skip, label: t('thisWeek.summary.skipped', { count: stats.skip }), dotColor: PaprikaEntry.skip.color });
  }

  if (items.length === 0) return null;

  return (
    <View style={styles.container}>
      {items.map((item, idx) => (
        <View key={idx} style={styles.item}>
          <View style={[styles.dot, { backgroundColor: item.dotColor }]} />
          <Text style={styles.count}>{item.count}</Text>
          <Text style={styles.label}>{item.label}</Text>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 3.5,
  },
  count: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 12.5,
    color: Paprika.textPrimary,
  },
  label: {
    fontFamily: 'Inter-Regular',
    fontSize: 12.5,
    color: Paprika.textMuted,
  },
});
